import React from "react";
import { track } from "../lib/analytics";

/*
  SMBF brand primitives.
  Monochrome type, deep-green accent, hairlines and restrained whitespace.
*/

export const BOOKING_URL = "https://content.thebitcoinadviser.com/meetings/andrew-finnie";

export function Wordmark({ className = "", subdued = false }) {
  return (
    <a href="/" aria-label="SMBF, Self-Managed Bitcoin Fund home" className={`group inline-flex items-baseline gap-2 ${className}`}>
      <span className="font-display text-xl font-semibold tracking-tight text-ink">SMBF</span>
      <span className={`hidden text-[11px] uppercase tracking-[0.22em] sm:inline ${subdued ? "text-grey" : "text-ink-soft"}`}>
        Self-Managed Bitcoin Fund
      </span>
    </a>
  );
}

export function Section({ id, children, className = "", band = false }) {
  return (
    <section
      id={id}
      className={`relative ${band ? "bg-paper-2" : ""} ${className}`}
      style={band ? { backgroundColor: "var(--paper-2)" } : undefined}
    >
      <div className="container-prose py-20 sm:py-28">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, className = "" }) {
  return <p className={`eyebrow ${className}`}>{children}</p>;
}

export function SectionHead({ eyebrow, title, lede, align = "left", max = "max-w-2xl" }) {
  const alignCls = align === "center" ? "text-center mx-auto" : "";
  return (
    <div className={`${alignCls} ${max}`}>
      {eyebrow && <Eyebrow className="mb-4">{eyebrow}</Eyebrow>}
      <h2 className="font-display text-3xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-4xl">
        {title}
      </h2>
      {lede && <p className="mt-5 text-lg leading-relaxed text-ink-soft">{lede}</p>}
    </div>
  );
}

export function CTAButton({ href, children, variant = "ink", external = true, className = "", loc, onClick, ...rest }) {
  const cls = variant === "ink" ? "btn-ink" : "btn-ghost";
  const extra = external ? { target: "_blank", rel: "noopener noreferrer" } : {};
  const handleClick = (e) => {
    const label = typeof children === "string" ? children : undefined;
    if (href === BOOKING_URL) track("book_a_call", { location: loc || label || "unknown" });
    else if (/get the guide/i.test(label || "")) track("get_the_guide", { location: loc });
    else track("cta_click", { href, label, location: loc });
    if (onClick) onClick(e);
  };
  return (
    <a href={href} onClick={handleClick} className={`${cls} ${className}`} {...extra} {...rest}>
      {children}
      {variant === "ink" && <span aria-hidden className="transition-transform duration-200 group-hover:translate-x-0.5">-&gt;</span>}
    </a>
  );
}

export function InkMark({ size = 40, label }) {
  return (
    <span
      className="inline-flex items-center justify-center rounded-full border border-jade/25 bg-white font-display font-semibold text-jade"
      style={{ width: size, height: size, fontSize: size * 0.42 }}
      aria-hidden={label ? undefined : true}
      aria-label={label}
    >
      B
    </span>
  );
}

export function NFAChip({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border border-border bg-white px-3 py-1 text-[11px] font-medium uppercase tracking-[0.14em] text-grey ${className}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-grey/60" aria-hidden /> General information - not advice
    </span>
  );
}
